<form [formGroup]="quantityForm" (ngSubmit)="onSubmit()" class="quantity-form">
  <div class="current-quantity-section">
    <div class="section-title">{{ 'pages.stock.edit.current_quantity' | translate }}</div>
    <div class="quantity-display">
      <span class="quantity-number">{{ stockData.stockQuantity }}</span>
      <span class="quantity-label">{{ 'pages.stock.edit.units' | translate }}</span>
    </div>
  </div>

  <div class="form-group">
    <label for="newQuantity" class="form-label required">
      {{ 'pages.stock.edit.new_quantity' | translate }}
    </label>
    <div class="quantity-input-container">
      <button type="button" class="quantity-btn minus" (click)="decreaseQuantity()">
        -
      </button>
      <input type="number" id="newQuantity" formControlName="newQuantity" class="quantity-input" min="0" step="1">
      <button type="button" class="quantity-btn plus" (click)="increaseQuantity()">
        +
      </button>
    </div>
    <div *ngIf="quantityForm.get('newQuantity')?.invalid && quantityForm.get('newQuantity')?.touched"
      class="error-message">
      {{ 'pages.stock.edit.quantity_required' | translate }}
    </div>
  </div>

  <div class="form-group">
    <label for="reason" class="form-label required">
      {{ 'pages.stock.edit.reason' | translate }}
    </label>
    <select id="reason" formControlName="reason" class="form-control">
      <option value="" disabled>{{ 'pages.stock.edit.select_reason' | translate }}</option>
      <option *ngFor="let option of reasonOptions" [value]="option.value">
        {{ option.label | translate }}
      </option>
    </select>
    <div *ngIf="quantityForm.get('reason')?.invalid && quantityForm.get('reason')?.touched" class="error-message">
      {{ 'pages.stock.edit.reason_required' | translate }}
    </div>
  </div>

  <div class="form-group">
    <label for="notes" class="form-label">
      {{ 'pages.stock.edit.notes' | translate }}
    </label>
    <textarea id="notes" formControlName="notes" class="form-control textarea" rows="3"
      placeholder="{{ 'pages.stock.edit.notes_placeholder' | translate }}">
    </textarea>
  </div>

  <div class="summary-section" *ngIf="quantityDifference !== 0">
    <div class="summary-title">{{ 'pages.stock.edit.summary' | translate }}</div>
    <div class="summary-content">
      <div class="summary-row">
        <span class="summary-label">{{ 'pages.stock.edit.current_stock' | translate }}:</span>
        <span class="summary-value">{{ stockData.stockQuantity }}</span>
      </div>
      <div class="summary-row">
        <span class="summary-label">{{ 'pages.stock.edit.new_stock' | translate }}:</span>
        <span class="summary-value">{{ newQuantity }}</span>
      </div>
      <div class="summary-row change-row">
        <span class="summary-label">{{ 'pages.stock.edit.change' | translate }}:</span>
        <span class="summary-value" [class.positive]="isDifferencePositive" [class.negative]="isDifferenceNegative">
          {{ isDifferencePositive ? '+' : '' }}{{ quantityDifference }}
        </span>
      </div>
    </div>
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-secondary" (click)="goBack()" [disabled]="isLoading">
      {{ 'common.back' | translate }}
    </button>
    <button type="submit" class="btn btn-primary"
      [disabled]="quantityForm.invalid || isLoading || quantityDifference === 0">
      <span *ngIf="isLoading" class="loading-spinner"></span>
      {{ 'pages.stock.edit.save_changes' | translate }}
    </button>
  </div>
</form>